import {
  Box,
  Button,
  Center,
  FormControl,
  FormErrorMessage,
  HStack,
  PinInput,
  PinInputField,
  Spinner,
  Stack,
} from "@chakra-ui/react";
import { useEffect } from "react";

import { EPinState } from "../../../../store/pinFormStore";
import { usePinFormState, usePinFormStateReaction } from "./hooks";

/**
 * This component is unfinished due to luck of requirements
 */
export function PinForm() {
  const { setError, pin, errorMessage, setPin, setState, state } = usePinFormState();
  usePinFormStateReaction();

  useEffect(() => {
    setError("");
  }, [pin]);

  const handleClick = () => {
    if (state === EPinState.Initial) {
      setState(EPinState.Validating);
    }
  };

  return (
    <Stack spacing={16}>
      <FormControl isInvalid={!!errorMessage}>
        <Center>
          <Box>
            <HStack justifyContent="center">
              <PinInput
                variant="brand"
                mask
                type="number"
                placeholder=""
                value={pin}
                onChange={setPin}
                autoFocus
              >
                <PinInputField maxW="42px" style={{ backgroundColor: "white" }} _focus={{ borderColor: "purple.500" }} />
                <PinInputField maxW="42px" style={{ backgroundColor: "white" }} _focus={{ borderColor: "purple.500" }} />
                <PinInputField maxW="42px" style={{ backgroundColor: "white" }} _focus={{ borderColor: "purple.500" }} />
                <PinInputField maxW="42px" style={{ backgroundColor: "white" }} _focus={{ borderColor: "purple.500" }} />
              </PinInput>
            </HStack>
            <Center textAlign="center">
              <FormErrorMessage>{errorMessage}</FormErrorMessage>
            </Center>
          </Box>
        </Center>
      </FormControl>

      <Button
        colorScheme="brand"
        onClick={handleClick}
        isLoading={state !== EPinState.Initial}
        spinner={<Spinner variant="white" />}
      >
        Продолжить
      </Button>
    </Stack>
  );
}
